import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API from "../services/api.auth";
import Navbar from "./Navbar";
import Marquee from "react-fast-marquee";
import { resolveImageSrc } from "../utils/imageUrl";
import { Button } from "react-bootstrap";

function WebListImage({ name, url }) {
  const initial = (name && name.trim()[0]) || "?";
  const [broken, setBroken] = useState(false);

  useEffect(() => {
    setBroken(false);
  }, [url]);

  if (url && !broken) {
    return (
      <img
        className="weblist-img"
        src={url}
        alt={name}
        loading="lazy"
        onError={() => setBroken(true)}
      />
    );
  }

  return (
    <span className="weblist-fallback is-visible" aria-hidden>
      {initial.toUpperCase()}
    </span>
  );
}

function AdminHomeScreen() {
  const [webList, setWebList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchWebLists = async () => {
      setError("");
      setLoading(true);
      try {
        const res = await API.get("/webList");
        setWebList(res.data);
      } catch (err) {
        const message =
          err?.response?.data?.message ||
          (typeof err?.response?.data === "string" ? err.response.data : "") ||
          err?.message ||
          "Failed to load weblists";
        setError(message);
      } finally {
        setLoading(false);
      }
    };

    fetchWebLists();
  }, []);

  useEffect(() => {
    document.title = "Free Credit - Admin Home Screen";
  }, []);

  const refresh = async () => {
    setError("");
    setLoading(true);
    try {
      const res = await API.get("/webList");
      setWebList(res.data);
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        (typeof err?.response?.data === "string" ? err.response.data : "") ||
        err?.message ||
        "Failed to load weblist";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const ok = window.confirm("Delete this weblist?");
    if (!ok) return;

    setError("");
    try {
      await API.delete(`/webList/${id}`);
      await refresh();
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        (typeof err?.response?.data === "string" ? err.response.data : "") ||
        err?.message ||
        "Failed to delete weblist";
      setError(message);
    }
  };

  return (
    <>
      <Marquee
        pauseOnHover
        speed={100}
        gradient={false}
        className="marquee-wrapper"
      >
        <span className="marquee-item">🔥 Welcome to Happy Coin!</span>
        <span className="marquee-item">
          🚚 Free Credit Online Casino Latest in Malaysia
        </span>
        <span className="marquee-item">🎉 New Arrivals Just Dropped</span>
        <span className="marquee-item">💳 Extra Cashback Available</span>
      </Marquee>

      <Navbar />

      <div className="d-flex justify-content-end">
        <Link to="/add" className="btn btn-primary m-3">
          Add Weblist
        </Link>
      </div>

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      {loading ? (
        <div className="d-flex align-items-center gap-2 text-secondary py-5 justify-content-center">
          <div
            className="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          />
          <span>Loading weblists...</span>
        </div>
      ) : webList.length === 0 ? (
        <div className="card shadow-sm">
          <div className="card-body text-center py-5">
            <p className="text-secondary mb-3">No weblists yet.</p>
            <Link to="/add" className="btn btn-primary">
              Add your first weblist
            </Link>
          </div>
        </div>
      ) : (
        <div className="row g-3">
          {webList.map((webL) => {
            const photoSrc = resolveImageSrc(webL, { cacheBust: true });

            return (
              <div key={webL.id} className="col-6 col-md-4 col-lg-3">
                <div className="card h-100 shadow-sm text-center">
                  {/* Image container */}
                  <div className="card-img-top">
                    <WebListImage name={webL.name} url={photoSrc} />
                  </div>

                  {/* Name */}
                  <div className="card-body p-2">
                    <p className="card-text fw-medium mb-0">{webL.name}</p>
                  </div>
                  <div className="d-flex justify-content-center mb-2">
                    <Link
                      to={`/edit/${webL.id}`}
                      className="btn btn-primary w-25 m-2"
                    >
                      Edit
                    </Link>
                    <Button
                      type="button"
                      className="btn btn-danger w-25 m-2"
                      onClick={() => handleDelete(webL.id)}
                    >
                      Delete
                    </Button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}

export default AdminHomeScreen;
